import React from "react";
import { useSelector } from "react-redux";

// Shown when the tenant has not set its own disclaimer in its appointment configuration.
const DEFAULT_NOTE =
  "Please arrive 10 minutes before your appointment time and carry a valid photo ID. For emergencies, contact the hospital directly.";

function Bottombar() {
  const isMobile = window.innerWidth <= 768;
  const disclaimer = useSelector((state) => state.dynamicStore.disclaimer);
  const hasDisclaimer = Boolean(String(disclaimer || "").trim());
  const label = hasDisclaimer ? "Disclaimer : " : "Note : ";

  return (
    <>
      <div className="bottombar-container">
        {isMobile ? (
          <span className="f500-16px text-white">{label}</span>
        ) : (
          <div className="f500-16px text-white">{label}</div>
        )}
        <span className={isMobile ? "f400-14px text-white":"f400-16px text-white"}>
          {hasDisclaimer ? disclaimer : DEFAULT_NOTE}
        </span>
      </div>
    </>
  );
}

export default Bottombar;
